(function () {
  var STATE_OPEN = 'state--landing-header-open';

  function parseCssPx(value) {
    var n = parseFloat(value);
    return Number.isFinite(n) ? n : 0;
  }

  function stickyOffsetPx() {
    var styles = window.getComputedStyle(document.body);
    var announcement = parseCssPx(styles.getPropertyValue('--cclp-announcement-height'));
    var header = parseCssPx(styles.getPropertyValue('--cclp-header-height'));
    if (!header) {
      header = window.matchMedia('(min-width: 1024px)').matches ? 75 : 70;
    }
    return announcement + header;
  }

  function findScrollTarget(hashId) {
    return window.CclpScrollTarget ? window.CclpScrollTarget.find(hashId) : null;
  }

  class CclpHeaderSection extends HTMLElement {
    constructor() {
      super();
      this._onToggleClick = this._onToggleClick.bind(this);
      this._onSmoothClick = this._onSmoothClick.bind(this);
      this._onSectionLoad = this._onSectionLoad.bind(this);
      this._onLandingHeaderClose = this._onLandingHeaderClose.bind(this);
    }

    connectedCallback() {
      var mode = this.dataset.headerMode || '';
      document.body.classList.remove('state--landing-header', 'state--no-header', 'state--cclp-lp-header');

      if (mode === 'lp_header') {
        document.body.classList.add('state--landing-header');
        document.body.classList.add('state--cclp-lp-header');
      } else if (mode === 'no_header') {
        document.body.classList.add('state--no-header');
      }

      var toggle = this.querySelector('.js-cclpHeaderToggle');
      if (toggle) {
        toggle.addEventListener('click', this._onToggleClick);
      }

      this._bindSmoothScroll();
      document.addEventListener('landing-header:close', this._onLandingHeaderClose);
      document.addEventListener('shopify:section:load', this._onSectionLoad);
    }

    disconnectedCallback() {
      var toggle = this.querySelector('.js-cclpHeaderToggle');
      if (toggle) {
        toggle.removeEventListener('click', this._onToggleClick);
      }

      this._unbindSmoothScroll();
      document.removeEventListener('landing-header:close', this._onLandingHeaderClose);
      document.removeEventListener('shopify:section:load', this._onSectionLoad);

      document.body.classList.remove('state--landing-header', 'state--no-header', 'state--cclp-lp-header');
    }

    _bindSmoothScroll() {
      this._unbindSmoothScroll();
      this.querySelectorAll('a.js-smoothScroll').forEach((el) => {
        el.addEventListener('click', this._onSmoothClick);
      });
    }

    _unbindSmoothScroll() {
      this.querySelectorAll('a.js-smoothScroll').forEach((el) => {
        el.removeEventListener('click', this._onSmoothClick);
      });
    }

    _onSectionLoad(event) {
      var target = event.target;
      if (target && typeof target.contains === 'function' && target.contains(this)) {
        this._bindSmoothScroll();
      }
    }

    _onLandingHeaderClose() {
      this._closeMobileMenu();
    }

    _closeMobileMenu() {
      document.body.classList.remove(STATE_OPEN);
      var toggle = this.querySelector('.js-cclpHeaderToggle');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }
    }

    _onToggleClick(ev) {
      var elToggle = ev.currentTarget;
      document.body.classList.toggle(STATE_OPEN);
      elToggle.setAttribute('aria-expanded', document.body.classList.contains(STATE_OPEN) ? 'true' : 'false');
    }

    _onSmoothClick(ev) {
      ev.preventDefault();
      var elLink = ev.currentTarget;
      var href = elLink.getAttribute('href');
      if (!href || href.indexOf('#') === -1) {
        return;
      }
      var parts = href.split('#');
      var sectionId = parts.length > 1 ? parts[parts.length - 1] : '';
      if (!sectionId) {
        return;
      }
      var elSection = findScrollTarget(sectionId);
      if (!elSection) {
        return;
      }
      var rect = elSection.getBoundingClientRect();
      var targetY = rect.top;
      var currentY = window.scrollY;
      var offset = stickyOffsetPx();
      var scrollY = currentY + targetY - offset;
      window.scroll({
        top: scrollY,
        left: 0,
        behavior: 'smooth',
      });
      this._closeMobileMenu();
    }
  }

  if (!customElements.get('cclp-header-section')) {
    customElements.define('cclp-header-section', CclpHeaderSection);
  }
})();
